module.exports = __webpack_public_path__ + "static/media/open_window_ico.83cda3da.svg";